import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, ControlContainer, FormGroup } from '@angular/forms';
import { combineLatest, Subscription } from 'rxjs';
import { Calendar } from 'src/app/classes';
import { Guid } from 'src/app/globals';
import { CalendarService } from 'src/app/lib/nextcloud/services/calendar.service';
import { FileService } from 'src/app/lib/nextcloud/services/file.service';
import { AppStateService } from 'src/app/services/app-state.service';

@Component({
  selector: 'app-event-form',
  templateUrl: './event-form.component.html',
  styleUrls: ['./event-form.component.css']
})
export class EventFormComponent implements OnDestroy, OnInit {

  formGroup: FormGroup;

  private _subscriptions: Subscription[] = [];

  constructor(
    private _controlContainer: ControlContainer,
    public calendarService: CalendarService
  ) { }

  displayCalendar(href: string){
    return FileService.getFileName(href);
  }

  ngOnDestroy(): void {
    for(let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this.formGroup = this._controlContainer.control as FormGroup;
    this._subscriptions.push(...[
      combineLatest(this.calendarIdentifierControl.valueChanges, this.calendarService.loadCalendars(true)).subscribe(([identifier, calendars]) => this.setCalendar(identifier, calendars))
    ]);
  }

  setCalendar(identifier, calendars: Calendar[]){
    let calendar = calendars.find(x => x.href === identifier);
    if(calendar){
      this.calendarControl.setValue(calendar);
      this.hrefControl.setValue(`${calendar.href}/${Guid.newGuid()}.ics`);
    }
  }

  get calendarControl(): AbstractControl {
    return this.formGroup.controls['calendar'];
  }
  get calendarIdentifierControl(): AbstractControl {
    return this.formGroup.controls['calendarIdentifier'];
  }
  get hrefControl(): AbstractControl {
    return this.formGroup.controls['href'];
  }

}
